export default __webpack_public_path__ + "static/8-f67fbe43e131a8fbb18d696b99c00f28.woff";